import { Component, createId, h } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { TheatreState } from "../../../hooks/useTheatreState";
import { getHandlerForTool, ToolHandler, ToolState } from "../../..";
import { ToolSlotRenderer } from "../../Tools/ToolSlotRenderer";
import { ListDropTarget } from "../ListDropTarget";

import classes from './ToolList.module.css';
import { Color } from "three";

export type ToolListProps = {
  state: TheatreState,
}

export const ToolList: Component<ToolListProps> = ({ state }) => {

  return [
    state.tools.toolbelts.map(toolbelt => {
      return h(html.section, { className: classes.toolbeltSection }, [
        h(html.div, { className: classes.header }, [
          // h('hr', { className: classes.line }),
          h(html.input, {
            type: 'color',
            value: '#' + toolbelt.color.getHexString(),
            className: classes.editableColorCircle,
            onInput(event) {
              state.tools.setToolbelt(toolbelt.id, { color: new Color(this.value) });
            },
          }),
          h(html.input, {
            className: classes.editableTitle,
            style: {
              color: '#' + toolbelt.color.getHexString(),
            },
            // contentEditable: 'plaintext-only',

            onInput() {
              state.tools.setToolbelt(toolbelt.id, { name: this.value });
            },
            value: toolbelt.name,
          }),

          h(html.button, { style: { margin: 'auto 0' }, disabled: state.tools.activeToolBelt === toolbelt.id, onClick() {
            state.tools.setActiveToolBelt(toolbelt.id)
          } }, 'Active'),
          h(html.button, { style: { margin: 'auto 0' }, onClick() {
            state.tools.removeToolbelt(toolbelt.id)
          } }, 'Delete'),
          // h('hr', { className: classes.line }),
        ]),
        h(ListDropTarget, {
          items: toolbelt.tools,
          itemSize: { x: 72 + 4, y: 72 },
          calcKey(item: ToolState) {
            return item.id;
          },
          renderItem(tool: ToolState) {
            const beltSlotIndex = toolbelt.tools.indexOf(tool);

            return h(ToolSlotRenderer, {
              key: tool.id,

              shortcutKey: null,
              tool,
              beltSlotIndex,
              state,
              draggable: true,
              onDblClick(e) {
                state.tools.setActiveToolBelt(toolbelt.id);
                state.tools.setActiveTool(tool.id);
              },
              onDragStart(e) {
                const dragData = e.dataTransfer;
                if (!dragData)
                  return;
                dragData.setDragImage(state.selection.emptyDragImage, 0, 0);

                state.selection.startDrag(
                  { type: 'tool', toolId: tool.id, toolState: tool },
                  { type: 'toolbelt', toolbeltId: toolbelt.id }
                )
              },
            })
          },
          renderGap() {
            return h(html.div, { style: {
              border: '4px dotted grey',
              borderRadius: '24px',
              transform: 'scale(0.8)',
              width: '64px',
              height: '64px',
            } })
          },
          state,
          acceptDrag(subject, source) {
            if (toolbelt.tools.length >= 9 && !(source.type === 'toolbelt' && source.toolbeltId === toolbelt.id))
              return false;
            return subject.type === 'tool';
          },
          findExistingIndex(subject, source) {
            if (subject.type === 'tool') {
              const index = toolbelt.tools.findIndex(tool => subject.toolId === tool.id);
              if (index !== -1)
                return index;
            }
            return null;
          },
          onDrop(subject, source, index, event) {
            if (subject.type !== 'tool')
              return;

            if (source.type === 'toolbelt') {
              if (source.toolbeltId !== toolbelt.id) {
                // delete from remove toolbelt
                const sourceToolbelt = state.tools.toolbelts.find(tb => tb.id === source.toolbeltId)!;

                state.tools.setToolbelt(source.toolbeltId, {
                  tools: sourceToolbelt.tools.filter(t => t.id !== subject.toolId)
                });
              }
            }

            const nextTools = [...toolbelt.tools]
              .filter(t => t.id !== subject.toolId);
            nextTools.splice(index, 0, subject.toolState);

            state.tools.setToolbelt(toolbelt.id, { tools: nextTools });
          },
          className: classes.toolList
        }),
      ])
    })
  ]
};
